var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "bv-modal-session-expired",
            centered: "",
            "hide-footer": "",
            "no-close-on-backdrop": true,
          },
          on: {
            close: function ($event) {
              return _vm.resetCart()
            },
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c("div", { staticClass: "modal-title__icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          role: "img",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 512 512",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "currentColor",
                            d: "M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.getTranslation(
                            "front",
                            "session_expired_modal_title"
                          )
                        ) +
                        "\n            "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "d-block text-center" }, [
            _c("br"),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.modalOptions.message) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("br"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-3 mx-auto",
                  on: {
                    click: function ($event) {
                      return _vm.redirectTo("/", true, _vm.modalOptions.action)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getTranslation(
                          "front",
                          "session_expired_modal_button_new_order"
                        )
                      ) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "mt-3 mx-auto",
                  on: {
                    click: function ($event) {
                      return _vm.redirectTo(
                        _vm.modalOptions.buttonLink,
                        true,
                        _vm.modalOptions.action
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.modalOptions.buttonText) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }